import { deleteRegrasFiscais, findRegrasFiscais, saveRegrasFiscais } from "@/api/regrasFiscais";
import { RegraFiscal } from "@/models/fiscal/RegrasFiscais";
import { RegrasFiscaisServiceAdapter } from "@/usecases/fiscal/adapter/RegrasFiscaisServiceAdapter";
import { injectable } from "inversify";

@injectable()
export class RegrasFiscaisService implements RegrasFiscaisServiceAdapter {
	findRegrasFiscais = async () => findRegrasFiscais()
	deleteRegrasFiscais = async (regrasFiscais: RegraFiscal) => deleteRegrasFiscais(regrasFiscais)
	saveRegrasFiscais = async(regraFiscal: RegraFiscal) => 
		saveRegrasFiscais(regraFiscal)
}